export const ENTITLED_STRIPE_SUBSCRIPTION_STATUSES = ['active', 'trialing'] as const;
export const RECOVERABLE_STRIPE_SUBSCRIPTION_STATUSES = ['past_due'] as const;

type StripeSubscriptionLike = {
  status?: unknown;
  current_period_end?: {
    seconds?: unknown;
  };
  cancel_at_period_end?: unknown;
  pending_update?: unknown;
};

export interface StripeSubscriptionSummary {
  renewalDate: number | null;
  cancelAtPeriodEnd: boolean;
  hasPendingUpdate: boolean;
  paymentPastDue: boolean;
}

const isEntitledStatus = (status: unknown): boolean => {
  return typeof status === 'string'
    && ENTITLED_STRIPE_SUBSCRIPTION_STATUSES.includes(status as typeof ENTITLED_STRIPE_SUBSCRIPTION_STATUSES[number]);
};

const periodEndMillis = (subscription: StripeSubscriptionLike): number => {
  const seconds = subscription.current_period_end?.seconds;
  return typeof seconds === 'number' && Number.isFinite(seconds) ? seconds * 1000 : 0;
};

export const summarizeStripeSubscriptions = (
  subscriptions: StripeSubscriptionLike[]
): StripeSubscriptionSummary => {
  const entitled = subscriptions.filter((subscription) => isEntitledStatus(subscription.status));
  const candidates = entitled.length > 0
    ? entitled
    : subscriptions.filter((subscription) => subscription.status === 'past_due');

  const selected = candidates.reduce<StripeSubscriptionLike | null>((latest, subscription) => {
    if (!latest) return subscription;
    return periodEndMillis(subscription) > periodEndMillis(latest) ? subscription : latest;
  }, null);

  return {
    renewalDate: selected && periodEndMillis(selected) > 0 ? periodEndMillis(selected) : null,
    cancelAtPeriodEnd: selected?.cancel_at_period_end === true,
    hasPendingUpdate: Boolean(selected?.pending_update),
    paymentPastDue: entitled.length === 0 && candidates.length > 0,
  };
};
